
import * as defaultImport from "@splunk/react-ui/Button";
export * from "@splunk/react-ui/Button";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
